import {ASLInductAreaReducer} from "../reducer/ASLInductAreaReducer";
import React, {createContext, useReducer} from "react";

export const ASLInductAreaContext = createContext()

const ASLInductAreaContextProvider = (props) => {
    const inductAreaInsight = {
        inductAreaMap: {},
        mheInductAreaMap: {}
    }
    const [viewModel, dispatch ] = useReducer(ASLInductAreaReducer, inductAreaInsight);
    return (
        <ASLInductAreaContext.Provider value = {{viewModel, dispatch}}>
            {props.children}
        </ASLInductAreaContext.Provider>
    )
}

export default ASLInductAreaContextProvider


// WEBPACK FOOTER //
// ./src/components/technician/context/ASLInductAreaContext.js